import { createContext } from "react";
import type { StudentToofiProviderValue } from "@/types/student-toofi";

export const StudentToofiContext = createContext<StudentToofiProviderValue | undefined>(undefined);
